import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

const KPI_CARDS = [
  { key: 'messages_sent', legacyKey: 'sent_count', label: 'Messages Sent' },
  { key: 'messages_delivered', legacyKey: 'delivered_count', label: 'Delivered' },
  { key: 'messages_read', legacyKey: 'read_count', label: 'Read' },
  { key: 'messages_failed', legacyKey: 'failed_count', label: 'Failed' },
];

const RATE_CHIPS = [
  { key: 'delivery_rate', label: 'Delivery Rate', suffix: '%' },
  { key: 'read_rate', label: 'Read Rate', suffix: '%' },
  { key: 'failure_rate', label: 'Failure Rate', suffix: '%' },
  { key: 'cta_ctr', label: 'CTA CTR', suffix: '%' },
];

function readCount(overview, key, legacyKey) {
  if (overview?.[key] != null) return overview[key];
  if (legacyKey && overview?.[legacyKey] != null) return overview[legacyKey];
  return 0;
}

export default function ReportingKpiCards({ overview, isLoading, showRates = true }) {
  return (
    <Box sx={{ mb: showRates ? 3 : 0 }}>
      <Grid container spacing={2}>
        {KPI_CARDS.map((card) => (
          <Grid item xs={12} sm={6} md={3} key={card.key}>
            <Card sx={{ boxShadow: 'none', bgcolor: 'grey.100', height: '100%' }}>
              <CardContent>
                <Typography variant="subtitle2" color="text.secondary">
                  {card.label}
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                  {isLoading ? '…' : readCount(overview, card.key, card.legacyKey)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {showRates ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
          {RATE_CHIPS.map((chip) => (
            <Card key={chip.key} sx={{ boxShadow: 'none', bgcolor: 'primary.50' }}>
              <CardContent sx={{ py: '8px !important', px: '12px !important' }}>
                <Typography variant="caption" color="text.secondary">
                  {chip.label}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  {isLoading ? '…' : `${overview?.[chip.key] ?? 0}${chip.suffix}`}
                </Typography>
              </CardContent>
            </Card>
          ))}
          {!isLoading && overview?.unique_cta_clickers != null ? (
            <Card sx={{ boxShadow: 'none', bgcolor: 'primary.50' }}>
              <CardContent sx={{ py: '8px !important', px: '12px !important' }}>
                <Typography variant="caption" color="text.secondary">
                  Unique CTA Clickers
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  {overview.unique_cta_clickers}
                </Typography>
              </CardContent>
            </Card>
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
}
